import { render } from "./Callback.vue?vue&type=template&id=f1cd3b16&scoped=true"
import script from "./Callback.vue?vue&type=script&lang=js"
export * from "./Callback.vue?vue&type=script&lang=js"

import "./Callback.vue?vue&type=style&index=0&id=f1cd3b16&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1cd3b16"]])

export default __exports__